import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Jade() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-28 md:py-36 bg-[#f2f5f0]" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div
            className={`transition-all duration-1000 ${
              visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <div className="relative">
              <div className="w-full h-[520px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20bracelet%20pendant%20necklace%20natural%20gemstone%20jewelry%20on%20white%20marble%20surface%20with%20green%20leaves%20luxury%20oriental%20product%20photography%20soft%20natural%20light%20elegant%20minimalist%20style%20high%20detail%20texture&width=700&height=900&seq=jade001&orientation=portrait"
                  alt="翡翠玉石"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Tag */}
              <div className="absolute top-6 left-6 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full border border-[#7a9e7e]/30">
                <span
                  className="text-[#4a7a52] text-[1rem] font-medium"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  東方文化
                </span>
              </div>
              {/* Decorative */}
              <div className="absolute -bottom-5 -right-5 w-32 h-32 rounded-full bg-[#7a9e7e]/10 border border-[#7a9e7e]/20"></div>
            </div>
          </div>

          {/* Right: Content */}
          <div
            className={`transition-all duration-1000 delay-200 ${
              visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#4a7a52]"></span>
              <span
                className="text-[#4a7a52] text-[1rem] tracking-[0.3em] font-medium"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                JADE & JADEITE
              </span>
            </div>

            <h2
              className="text-[#2d2520] font-bold mb-6 leading-[1.4]"
              style={{
                fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
                fontFamily: "'Noto Serif TC', serif",
              }}
            >
              翡翠玉石
              <br />
              <span className="text-[#4a7a52]">東方文化中的吉祥象徵</span>
            </h2>

            <p
              className="text-[#5a4e45] leading-[1.75] mb-8"
              style={{
                fontSize: "1.1875rem",
                fontFamily: "'Noto Serif TC', serif",
              }}
            >
              玉石自古被視為純潔、吉祥與守護的象徵。瓏靖精選各類翡翠玉石，將天然美感與文化寓意融合，呈現溫潤典雅的能量飾品。
            </p>

            {/* Features */}
            <div className="space-y-5 mb-10">
              {[
                { title: "溫潤典雅", desc: "玉石溫潤的質感與光澤，展現東方美學的含蓄之美" },
                { title: "吉祥守護", desc: "自古以來，玉石被視為吉祥、平安與守護的象徵" },
                { title: "天然珍稀", desc: "每一件翡翠玉石都是大自然億萬年孕育的珍貴禮物" },
              ].map((item) => (
                <div key={item.title} className="flex gap-4">
                  <div className="w-2 h-2 rounded-full bg-[#4a7a52] mt-3 flex-shrink-0"></div>
                  <div>
                    <h4
                      className="text-[#2d2520] font-semibold mb-1"
                      style={{
                        fontSize: "1.1875rem",
                        fontFamily: "'Noto Serif TC', serif",
                      }}
                    >
                      {item.title}
                    </h4>
                    <p
                      className="text-[#7a6a5a] leading-[1.75]"
                      style={{
                        fontSize: "1.1875rem",
                        fontFamily: "'Noto Serif TC', serif",
                      }}
                    >
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate("/products?category=jade")}
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#4a7a52] text-white rounded-full text-[1rem] font-medium tracking-widest cursor-pointer hover:bg-[#3d6644] transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              探索翡翠系列
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
